import { BookingViewModel } from './../../../core/backend/models/booking-view-model';
import {
  getCreatorBookings,
  getFollowingUsers,
  getOwnLikes,
  getUser,
  getUserBookings,
  getUserPaymentMethods
} from '../../../core/api';
import {
  LikeViewModel,
  PaymentMethodViewModel,
  UserFollowingViewModel,
  UserViewModel
} from '../../../core/backend/models';
import { APPLE_PAY_METHOD, GOOGLE_PAY_METHOD } from '../../../core/consts';
import { TrackingEvents } from '../../../core/enums';
import {
  iOS,
  isAppleDevice,
  isChromeBrowser,
  isInstagramInAppBrowser,
  isSafariBrowser
} from '../../../core/helpers';
import MixpanelTracking from '../../../core/services/MixpanelTracking';

interface SessionData {
  user: UserViewModel;
  userBookings: BookingViewModel[];
  creatorBookings: BookingViewModel[];
  userLikes: LikeViewModel[];
  paymentMethods: PaymentMethodViewModel[];
  following: UserFollowingViewModel[];
}

export const getAllUserData = async (): Promise<SessionData> => {
  let creatorBookings: BookingViewModel[] = [];
  const user = await getUser();
  const userBookings = await getUserBookings();
  const userLikes = await getOwnLikes();
  const paymentMethods = await getUserPaymentMethods();
  const following = await getFollowingUsers();

  if (user.isCreatorPro) creatorBookings = await getCreatorBookings();

  const _paymentMethods: PaymentMethodViewModel[] = [];
  if (isAppleDevice() && (isSafariBrowser() || isInstagramInAppBrowser()))
    _paymentMethods.push(APPLE_PAY_METHOD);

  if (!iOS() && (isChromeBrowser() || isInstagramInAppBrowser()))
    _paymentMethods.push(GOOGLE_PAY_METHOD);

  return {
    user,
    userBookings,
    creatorBookings,
    userLikes,
    paymentMethods: _paymentMethods.concat(paymentMethods),
    following
  };
};
